module.exports = __webpack_public_path__ + "img/Elena-Zalbide-Elorduy.8d35e695.png";